import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    Typography,
    Divider,
    Grid,
    Chip,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export default function NotificationAndCommunitactionProtocol({
    open,
    onClose,
    markaUnvan = "",
    markaMersisVno = "",
    markaAdres = "",
    markaTemsilciAdSoyad = "",
    markaEposta = "",
    markaTel = "",
}) {
    const Section = ({ title, children, id }) => (
        <Box id={id} sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>{children}</Box>
        </Box>
    );

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
            <Grid item xs={4} sm={3} md={2}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Typography variant="body2">{value}</Typography>
            </Grid>
        </Grid>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{ sx: { borderRadius: 4, p: 0.5 } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 6 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" fontWeight={800}>Tebligat ve Bildirim Protokolü</Typography>
                    <Chip size="small" label={(new Date()).toLocaleDateString("tr-TR")} />
                </Stack>
                <IconButton aria-label="Kapat" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Taraflar */}
                <Section title="Taraflar" id="taraflar">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Alcago</Typography>
                    <Box sx={{ mb: 2 }}>
                        <InfoRow label="Unvan" value='Alcago Teknoloji Anonim Şirketi ("Alcago")' />
                        <InfoRow label="MERSİS" value="0050117816000001" />
                        <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                        <InfoRow label="E-posta" value="destek@alcago.com" />
                        <InfoRow label="Telefon" value="0539 397 13 63" />
                    </Box>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Marka</Typography>
                    <Box>
                        <InfoRow label="Unvan" value={`${markaUnvan} ("Marka")`} />
                        <InfoRow label="MERSİS/Vergi No" value={markaMersisVno} />
                        <InfoRow label="Adres" value={markaAdres} />
                        <InfoRow label="Temsilci" value={markaTemsilciAdSoyad} />
                        <InfoRow label="E-posta" value={markaEposta} />
                        <InfoRow label="Telefon" value={markaTel} />
                    </Box>
                </Section>

                {/* 1. Amaç */}
                <Section title="1. Amaç" id="amac">
                    <Typography>
                        İşbu Protokol, Taraflar arasında yapılacak tüm bildirimlerin, tebligatların ve hukuki yazışmaların geçerli adres ve yöntemlerini belirlemek amacıyla düzenlenmiştir.
                    </Typography>
                </Section>

                {/* 2. Tebligat Adresleri */}
                <Section title="2. Tebligat Adresleri" id="adresler">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Alcago için geçerli tebligat adresi yukarıda belirtilmiştir.</li>
                        <li>Marka için geçerli tebligat adresi yukarıda belirtilmiştir.</li>
                        <li>Taraflar, adres değişikliklerini en geç 7 (yedi) gün içinde yazılı olarak veya panel üzerinden bildirmekle yükümlüdür. Aksi halde eski adreslere yapılan tebligatlar geçerli kabul edilir.</li>
                    </ul>
                </Section>

                {/* 3. Elektronik Bildirimler */}
                <Section title="3. Elektronik Bildirimler" id="ebildirim">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Taraflar arasındaki yazışmaların e-posta yoluyla yapılması mümkündür.</li>
                        <li>Alcago’nun paneli üzerinden yapılan bildirimler, Marka tarafından erişildiği anda geçerli sayılır.</li>
                        <li>E-posta ile yapılan bildirimler gönderim kayıtları ve sistem loglarıyla ispatlanabilir.</li>
                    </ul>
                </Section>

                {/* 4. Elektronik Kayıtların Delil Niteliği */}
                <Section title="4. Elektronik Kayıtların Delil Niteliği" id="delil">
                    <Typography>
                        Taraflar, panel kayıtları, elektronik loglar, e-posta yazışmaları ve fatura kayıtlarının Hukuk Muhakemeleri Kanunu m.193 uyarınca kesin delil teşkil edeceğini kabul eder.
                    </Typography>
                </Section>

                {/* 5. Uyuşmazlıklar */}
                <Section title="5. Uyuşmazlıklar" id="uyusmazlik">
                    <Typography>
                        İşbu Protokolden doğacak uyuşmazlıklarda Türk Hukuku uygulanır. İstanbul (Çağlayan) Merkez Mahkemeleri ve İcra Daireleri yetkilidir.
                    </Typography>
                </Section>

                {/* 6. Yürürlük */}
                <Section title="6. Yürürlük" id="yururluk">
                    <Typography>
                        İşbu Protokol, elektronik ortamda onaylandığı tarihte yürürlüğe girer ve ana hizmet sözleşmesi süresince geçerliliğini korur.
                    </Typography>
                </Section>

                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Button variant="outlined" onClick={onClose}>Kapat</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
